// extracted by mini-css-extract-plugin
export default {"container":"manage-sensors_container__eRSTa","title":"manage-sensors_title__Dy8rC"};